export default __webpack_public_path__ + "static/media/loading-bg.c20fe93a.jpg";